// NewsArchive filter + pagination
// ==========================================
import mixitup from 'mixitup';
import mixitupPagination from '../js/mixitup-pagination.min.js';
import mixitupMultiFilter from '../js/mixitup-multifilter.min.js';

const newsArchiveEl = document.getElementById('NewsArchive');
const articlesContainerEl = document.getElementById('articlesContainer');
const paginationCurrentPageEl = document.querySelector(
  '.pagination__current'
) as HTMLElement;
const paginationTotalPagesEl = document.querySelector(
  '.pagination__total'
) as HTMLElement;
const paginationNextElements = document.querySelectorAll('.pagination__next');
const paginationPrevElements = document.querySelectorAll('.pagination__back');
const filterButtonElements = document.querySelectorAll(
  '.filter-dropdown__list-item'
);

export const newsArchiveMixItUp = () => {
    // Interface for object to store active filter data
    interface QueryStringObject {
        category?: string;
        year?: string;
        page?: string;
    }
  
    const createQueryObjectFromString = (str: string): QueryStringObject => {
    let query: QueryStringObject = {
        category: '',
        year: '',
        page: '',
    };

    let splitString = str.split('&');

    splitString.forEach((s) => {
        if (s.includes('category')) query.category = s.split('=')[1];
        if (s.includes('year')) query.year = s.split('=')[1];
        if (s.includes('page')) query.page = s.split('=')[1];
    });

    return query;
    };

    const createSearchString = (query: QueryStringObject): string => {
    let str = '';

    if (document.querySelector('[data-filter-group="category"]'))
        str += query.category != '' ? '&category=' + query.category : '';
    if (document.querySelector('[data-filter-group="year"]'))
        str += query.year != '' ? '&year=' + query.year : '';

    // Page below is used for pagination in CompetitionCalendar
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('page');
    if (myParam != undefined) str += myParam != '' ? '&page=' + myParam : '';

    return str;
    };

    // Update search string when filters are toggled
    const updateSearchString = () => {
    let categoryFilter = document.querySelector('.filter__category');
    let categoryFilterItem = categoryFilter?.querySelector(
        '.mixitup-control-active'
    );
    let yearFilter = document.querySelector('.filter__year');
    let yearFilterItem = yearFilter?.querySelector('.mixitup-control-active');

    let categoryFilterString = '';
    if (
        categoryFilterItem != undefined &&
        categoryFilterItem.getAttribute('data-label-clean') != null
    ) {
        categoryFilterString += categoryFilterItem.getAttribute('data-label-clean');
    }
    let yearFilterString = '';
    if (
        yearFilterItem != undefined &&
        yearFilterItem.getAttribute('data-label-clean') != null
    ) {
        yearFilterString += yearFilterItem.getAttribute('data-label-clean');
    }

    // PageString is used for pagination in CompetitionCalendar
    let pageString = '';
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('page');
    if (myParam != undefined) {
        pageString = myParam;
    }

    let queryObject: QueryStringObject = {
        category: categoryFilterString,
        year: yearFilterString,
        page: pageString,
    };

    let queryString = createSearchString(queryObject);

    if (queryString.match(/&/)) queryString = queryString.replace('&', '');

    window.history.replaceState({}, '', '?' + queryString);
    };

    //  Activate/set selected filters. Called when page loads
    //  @param archiveMixer - the instance of mixer
    const activateFilters = (mixer: any) => {
    if (window.location.search.length > 1) {
        let locationSearch = window.location.search;

        let initialQuery: QueryStringObject =
        createQueryObjectFromString(locationSearch);

        if (mixer != null) {
        // Category
        let categoryQuery = initialQuery.category;
        if (
            document.querySelector('[data-filter-group="category"]') &&
            categoryQuery != ''
        )
            mixer.setFilterGroupSelectors('category', '.' + categoryQuery);

        // Year
        let yearQuery = initialQuery.year;
        if (
            document.querySelector('[data-filter-group="year"]') &&
            yearQuery != ''
        )
            mixer.setFilterGroupSelectors('year', '.year-' + yearQuery);

        // Parse setFilterGroupSelectors above
        mixer.parseFilterGroups();
        }
    }
    };

    // Function that checks and updates relevant elements in regards to mixitup pagination data
    const updatePaginationElements = (mixer: any) => {
    if (mixer != undefined) {
        mixer.paginate(1);
        setTimeout(() => {
        let currentPage = mixer.getState().activePagination?.page;
        let totalCurrentPages = mixer.getState().totalPages;

        // if there are more pages than one, enable next navigation
        if (totalCurrentPages > 1) {
            Array.from(paginationNextElements).forEach((element) => {
            element.classList.remove('disabled');
            });
            updatePageCounter(mixer);
        }

        // if current filter is only 1 page, hide pagination
        if (totalCurrentPages == 1) {
            Array.from(paginationPrevElements).forEach((element) => {
            element.classList.add('disabled');
            });
            Array.from(paginationNextElements).forEach((element) => {
            element.classList.add('disabled');
            });
            updatePageCounter(mixer);
        }

        // if current page is the first page, disable navigation
        if (currentPage == 1) {
            Array.from(paginationPrevElements).forEach((element) => {
            element.classList.add('disabled');
            });
        } else {
            Array.from(paginationPrevElements).forEach((element) => {
            element.classList.remove('disabled');
            });
        }
        }, 100);
    }
    };

    // NEXT PAGE FUNCTION
    const nextPageFunction = (mixer: any) => {
    mixer.paginate('next').then(function (state) {
        let currentPage = mixer.getState().activePagination.page;
        let totalPages = mixer.getState().totalPages;

        if (currentPage == totalPages) {
        Array.from(paginationNextElements).forEach((element) => {
            element.classList.add('disabled');
        });
        }
        Array.from(paginationPrevElements).forEach((element) => {
        if (element.classList.contains('disabled')) {
            element.classList.remove('disabled');
        }
        });
    });
    updatePageCounter(mixer);
    };

    // PREVIOUS PAGE FUNCTION
    const prevPageFunction = (mixer: any) => {
    mixer.paginate('prev').then(function (state) {
        let currentPage = mixer.getState().activePagination.page;
        let totalPages = mixer.getState().totalPages;

        if (currentPage == 1) {
        Array.from(paginationPrevElements).forEach((element) => {
            element.classList.add('disabled');
        });
        }

        Array.from(paginationNextElements).forEach((element) => {
        if (element.classList.contains('disabled')) {
            element.classList.remove('disabled');
        }
        });
    });
    updatePageCounter(mixer);
    };

    // Function to call onMixEnd
    const mixEndFunction = (state) => {
    updateSearchString();
    };

    if (articlesContainerEl != undefined) {
    mixitup.use(mixitupPagination);
    mixitup.use(mixitupMultiFilter);

    // If desktop show 7 pagers, else only 5
    let pagers = screen.width > 500 ? 7 : 5;

    var archiveMixer = mixitup(articlesContainerEl, {
        multifilter: {
        enable: true,
        },
        pagination: {
        limit: 6,
        maxPagers: pagers,
        },
        animation: {
        enable: false,
        },
        callbacks: {
        onMixEnd: mixEndFunction,
        },
        templates: {
        pagerPrev:
            '<button class="${classNames}" title="Föregående sida" data-page="prev"><svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.828 12L15.778 16.95L14.364 18.364L8 12L14.364 5.63599L15.778 7.04999L10.828 12Z" fill="#09121F" /></svg>Föregående</button>',
        pagerNext:
            '<button class="${classNames}" title="Nästa sida" data-page="next">Nästa<svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.1719 12L8.22192 7.04999L9.63592 5.63599L15.9999 12L9.63592 18.364L8.22192 16.95L13.1719 12Z" fill="#09121F" /></svg></button>',
        },
    });

    // PREVIOUS PAGE EVENT LISTENTER
    if (
        newsArchiveEl != undefined &&
        paginationPrevElements != undefined &&
        paginationNextElements != undefined
    ) {
        Array.from(paginationPrevElements).forEach((element) => {
        element.addEventListener('click', () => {
            prevPageFunction(archiveMixer);
        });
        });
    }

    // NEXT PAGE EVENT LISTENTER
    if (
        newsArchiveEl != undefined &&
        paginationNextElements != undefined &&
        paginationPrevElements != undefined
    ) {
        Array.from(paginationNextElements).forEach((element) => {
        element.addEventListener('click', () => {
            nextPageFunction(archiveMixer);
        });
        });
    }

    // Set filters on load
    activateFilters(archiveMixer);
    updatePaginationElements(archiveMixer);
    }

    // Function that updates page counter
    const updatePageCounter = (mixer: any) => {
    if (
        paginationCurrentPageEl != undefined &&
        paginationTotalPagesEl != undefined
    ) {
        let currentPage = mixer.getState().activePagination.page;
        let totalCurrentPages = mixer.getState().totalPages;
        paginationCurrentPageEl.innerHTML = currentPage;
        paginationTotalPagesEl.innerHTML = totalCurrentPages;
    }
    };

    // Check pagination status on filter change
    if (filterButtonElements != undefined) {
    Array.from(filterButtonElements).forEach((element) => {
        element.addEventListener('click', () => {
        updatePaginationElements(archiveMixer);
        });
    });
    }
}

